import { Button, Col, Form, InputNumber, Row, Select, Typography } from "antd";
import { Table } from "antd";
import { useState } from "react";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

export default function CurrencyDenominationInfo({
  form,
  currencyOptions,
  denominationOptions,
  denominationEntries,
  setDenominationEntries,
}) {
  const handleAddDenomination = () => {
    const values = form.getFieldsValue();
    const { currency, currencyDenomination, denominationCount, denominationValue } = values;
    console.log(currency, "currency");
    console.log(currencyDenomination, "currencyDenomination");

    if (currency && currencyDenomination && denominationCount && denominationValue) {
      // const existingEntry = denominationEntries.find(
      //   (e) => e.currency.toLowerCase() === currency.toLowerCase(),
      // );
      // if (existingEntry) {
      //   BOM.AlertMsg(cnt.DANGER, "Currency already exists");
      //   return;
      // }
      const newEntry = {
        key: Date.now(),
        currency: currencyOptions.find((c) => c.value === currency)?.label,
        denomination: currencyDenomination,
        count: denominationCount,
        value: denominationValue,
      };
      setDenominationEntries([...denominationEntries, newEntry]);
      form.setFieldsValue({
        currencyDenomination: undefined,
        denominationCount: undefined,
        denominationValue: undefined,
      });
    }
  };
  const denominationColumns = [
    { title: "Currency", dataIndex: "currency", key: "currency" },
    { title: "Denomination", dataIndex: "denomination", key: "denomination" },
    { title: "Count", dataIndex: "count", key: "count" },
    { title: "Value", dataIndex: "value", key: "value" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          className="of-primaryBtnColor"
          icon={<DeleteOutlined />}
          onClick={() =>
            setDenominationEntries(denominationEntries.filter((e) => e.key !== record.key))
          }
        />
      ),
    },
  ];
  const handleDenominationChange = (value) => {
    const count = form.getFieldValue("denominationCount");
    console.log(count);
    if (value && count) {
      form.setFieldValue("denominationValue", value * count);
    }
  };

  const handleCountChange = (value) => {
    const denom = form.getFieldValue("currencyDenomination");
    console.log(denom);
    if (denom && value) {
      form.setFieldValue("denominationValue", denom * value);
    }
  };
  return (
    <div>
      <Form form={form} layout="vertical" onFinish={handleAddDenomination}>
        <Title level={5}>Currency Denomination Info</Title>
        <Row gutter={16} align="bottom" style={{ marginBottom: 12 }}>
          <Col span={6}>
            <Form.Item
              name="currency"
              label={<Text strong>Currency</Text>}
              rules={[
                {
                  required: true,
                  message: "Currency is required",
                },
              ]}
            >
              <Select
                style={{ width: "100%", height: 44 }}
                options={currencyOptions}
                placeholder="Select currency"
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="currencyDenomination"
              label={<Text strong>Currency Denomination</Text>}
              rules={[
                {
                  required: true,
                  message: "Currency denomination is required",
                },
              ]}
            >
              <Select
                style={{ width: "100%", height: 44 }}
                options={denominationOptions}
                placeholder="Select denomination"
                onChange={handleDenominationChange}
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="denominationCount"
              label={<Text strong>Denomination count</Text>}
              rules={[
                {
                  required: true,
                  message: "Denomination count is required",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%", height: 44, paddingTop: 6 }}
                onChange={handleCountChange}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="denominationValue" label={<Text strong>Denomination value</Text>}>
              <InputNumber
                style={{ width: "100%", height: 44, paddingTop: 6 }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            {/* <Form.Item label=" "> */}
            <Button
              type="primary"
              className="of-primaryBtnColor"
              style={{ height: 44 }}
              onClick={handleAddDenomination}
            >
              Add
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </Form>

      {denominationEntries.length > 0 && (
        <Table
          style={{ marginTop: 16, marginBottom: 24 }}
          dataSource={denominationEntries}
          columns={denominationColumns}
          pagination={false}
          size="small"
        />
      )}
    </div>
  );
}
